export default __webpack_public_path__ + "images/94d8c13b400f3d6118dfe10ec00f45d0-hinduism.webp";